<template>
  <BaseGridView
    endpoint="v1/AccountTransaction/GetData"
    :pageTitle="$t('Account Transactions')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
  >
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "accountNo",
    "amount",
    "createdDateTimeOffset",
    "currencyCode",
    "lastChangedDateTimeOffset",
    "postingDate",
    "voucherNo",
    "voucherDescription",
    "voucherDate",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
      width: 200,
   
    },
    {
      field: "accountNo",
      headerText: instance?.$t("accountNo"),
    },
    { field: "amount", headerText: instance?.$t("amount") },
    {
      field: "createdDateTimeOffset",
      headerText: instance?.$t("createdDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "currencyCode", headerText: instance?.$t("currencyCode") },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    {
      field: "postingDate",
      headerText: instance?.$t("postingDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "voucherNo", headerText: instance?.$t("voucherNo") },
    {
      field: "voucherDescription",
      headerText: instance?.$t("voucherDescription"),
    },
    {
      field: "voucherDate",
      headerText: instance?.$t("voucherDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
  ];
};
</script>
